import React from 'react';

import Cookies from 'js-cookie';

import { CreateCreditApplicationAttributionContext } from 'src/clients/Network/gql/build/TermsAndConditionsPageMutation.graphql';
import {
  CkBadgeCookieKey,
  CkOfferVariantCookieKey,
  CkPayloadCookieKey,
  CkSubIdCookieKey,
  InviteCookieKey,
  UtmCampaignCookieKey,
  UtmContentCookieKey,
  UtmMediumCookieKey,
  UtmSourceCookieKey,
  UtmTermCookieKey,
  X1InviteCookieKey,
} from 'src/components/creditApplication/NavigationProvider';

export enum Campaign {
  AgenticCard = 'agentic-card',
  NfaStanford = 'nfa-stanford',
}

const DEFAULT_UTM_SOURCE = 'rh-card-web';

export const getAttribution = (
  ckSubId?: string,
  ckBadge?: string,
  ckPayload?: string,
  ckOfferVariant?: string,
  x1Invite?: string,
): CreateCreditApplicationAttributionContext => {
  const invite = Cookies.get(InviteCookieKey);
  const utmSource = Cookies.get(UtmSourceCookieKey) ?? DEFAULT_UTM_SOURCE;
  const utmCampaign = Cookies.get(UtmCampaignCookieKey);
  const utmMedium = Cookies.get(UtmMediumCookieKey);
  const utmContent = Cookies.get(UtmContentCookieKey);
  const utmTerm = Cookies.get(UtmTermCookieKey);
  const baseAttribution: CreateCreditApplicationAttributionContext = {
    inviteKey: invite,
    utmParams: { source: utmSource, medium: utmMedium, campaign: utmCampaign, content: utmContent, term: utmTerm },
  };

  // Prefer X1 invite over CK sub ID and badge
  const x1InviteSlug = x1Invite ?? Cookies.get(X1InviteCookieKey);
  const affiliateAttribution = !!x1InviteSlug
    ? {
        x1InviteSlug: x1InviteSlug,
      }
    : {
        creditKarmaTrackingId: ckSubId ?? Cookies.get(CkSubIdCookieKey),
        creditKarmaLightboxBadge: ckBadge ?? Cookies.get(CkBadgeCookieKey),
        creditKarmaTrackingPayload: ckPayload ?? Cookies.get(CkPayloadCookieKey),
        creditKarmaOfferVariant: ckOfferVariant ?? Cookies.get(CkOfferVariantCookieKey),
      };

  return {
    ...baseAttribution,
    ...affiliateAttribution,
  };
};

export const useIsNfaStanford = () => {
  const { inviteKey, utmParams } = getAttribution();
  return inviteKey != null && utmParams?.campaign === Campaign.NfaStanford;
};
